import { Suspense } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import CompanyProvider, { useCompanyCtx } from './integrations/Company';
import MachineProvider, { useMachineCtx } from './integrations/Machine';
import PipTestProvider, { usePipTestCtx } from './integrations/PipTest';
import MaterialsProvider, { useMaterialCtx } from './integrations/Material';
import VersionProvider, { useVersionCtx } from './integrations/Version';
import AuthProvider from './Auth';
import './chartTheme';

const Integrations = ({ children }) => (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <AuthProvider>
            <CompanyProvider>
                <VersionProvider>
                    <MachineProvider>
                        <PipTestProvider>
                            <MaterialsProvider>{children}</MaterialsProvider>
                        </PipTestProvider>
                    </MachineProvider>
                </VersionProvider>
            </CompanyProvider>
        </AuthProvider>
    </GoogleOAuthProvider>
);

export const useIntegrations = () => {
    const integrations = {
        company: useCompanyCtx(),
        machine: useMachineCtx(),
        pipTest: usePipTestCtx(),
        material: useMaterialCtx(),
        version: useVersionCtx(),
    };

    const isAnyLoading = Object.values(integrations).some(
        ({ isLoading }) => isLoading
    );

    return {
        ...integrations,
        isAnyLoading,
    };
};

export const RouteData = ({ children }) => {
    return <Suspense>{children}</Suspense>;
};

export default Integrations;
